import { env } from '../common.constants';

export const GET_CHAT_SUBJECTS: string = env + 'chat/messages/';
export const GET_CHAT_HISTORY: string = env + 'chats/';
export const SEND_CHAT_MESSAGE: string = env + 'chat/create';

//WEB SOCKETS
export const SOCKET_URL = 'ws://localhost:9190/nazouki/chat';
export const SOCKET_CHAT_NOTIFICATION_ENDPOINT_URL = '/topic/messages/';